import type {
  Selection,
  ToteSelection,
  FobPropositionSelection,
  RacingBetType,
  BettingType,
  KambiSportsSelection,
} from '@mobi/betslip/types'
import { isNoveltyBetType } from '@mobi/betslip/helpers/typeGuards'
import { Currency } from '@mobi/utils/money'

export function getMarketTitle(selection: Selection) {
  if ((selection as ToteSelection).betType) {
    return (selection as ToteSelection).betType
  }
  if ((selection as FobPropositionSelection).marketCode) {
    return (selection as FobPropositionSelection).marketName
  }
  const defaultVal: Extract<RacingBetType, 'Win & Place'> = 'Win & Place'
  return defaultVal
}

export function getFixedOrToteDisplay(selection: Selection, bettingType: BettingType) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (isNoveltyBetType((selection as any).betType)) {
    return ''
  }
  if (bettingType === 'fixed-odds-racing' && !(selection as FobPropositionSelection).marketCode) {
    return 'Fixed'
  }
  if (bettingType === 'tote-racing') {
    return 'Tote'
  }
  return ''
}

export function getPriceFromKambiSportsSelection(selection: KambiSportsSelection): number {
  if (selection.betSelectionType === 'single') {
    const selectedOutcome = selection.betOffers[0].outcomes.find(
      outcome => outcome.id === selection.outcomeIds[0]
    )
    if (!selectedOutcome) return 1
    return new Currency(selectedOutcome.odds, { dollarMultiplier: 1000 }).value
  }

  return 1
}
